import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { filter, path } from 'ramda';
import { FormattedMessage } from 'react-intl';

import Paper from 'components/Paper';
import HistoryCollapseContainer from 'containers/HistoryCollapseContainer';

import CommonHeader from 'routes/Documents/components/CommonHeader';
import BottomFormControls from 'routes/Documents/components/BottomFormControls';
import normalize from 'lib/normalize';

import EditableV2 from 'routes/Documents/containers/EditableV2';
import { getLatestUnfinishedCommit } from 'lib/documentHandling';

import Form from './Form';
import historyMapper, { sorter } from './historyMapper';

const Comorbidity = ({ names, documents, editingDocument, onStartEdit, onCreate }) => (
  <div>
    <Paper topMargin={false}>
      <Grid fluid>
        <CommonHeader
          names={names}
          localeId="comorbidity.title"
          infoText="comorbidity.infoText"
          addNewText="comorbidity.addNew"
          mode="create"
          editing={editingDocument}
          startEdit={onCreate}
        />
      </Grid>
      {editingDocument && (
        <EditableV2
          documentId={editingDocument.documentId}
          moduleName={names[0]}
          editedCommit={getLatestUnfinishedCommit(editingDocument)}
        >
          <Form />
        </EditableV2>
      )}
      {!editingDocument && (
        <div>
          <HistoryCollapseContainer
            documents={filter(d => !path(['content', 'diagnosisType'], d), normalize(documents))}
            emptyText=""
            sorter={sorter}
            mapper={historyMapper(names[0], onStartEdit)}
            limit={3}
            noNormalize
          />
          <h4
            style={{
              padding: '1rem',
              paddingLeft: '2rem',
              marginTop: '3rem',
              marginBottom: '-2rem',
              color: 'white',
              backgroundColor: '#81c5c0',
            }}
          >
            <FormattedMessage id="comorbidity.headers.comorbidity" />
          </h4>
          <HistoryCollapseContainer
            documents={filter(d => path(['content', 'diagnosisType'], d) === 'comorbidity', normalize(documents))}
            emptyText="comorbidity.emptyText.comorbidity"
            sorter={sorter}
            mapper={historyMapper(names[0], onStartEdit)}
            limit={3}
            noNormalize
          />
          <h4
            style={{
              padding: '1rem',
              paddingLeft: '2rem',
              marginTop: '3rem',
              marginBottom: '-2rem',
              color: 'white',
              backgroundColor: '#81c5c0',
            }}
          >
            <FormattedMessage id="comorbidity.headers.infection" />
          </h4>
          <HistoryCollapseContainer
            documents={filter(d => path(['content', 'diagnosisType'], d) === 'infection', normalize(documents))}
            emptyText="comorbidity.emptyText.infection"
            sorter={sorter}
            mapper={historyMapper(names[0], onStartEdit)}
            limit={3}
            noNormalize
          />
          <h4
            style={{
              padding: '1rem',
              paddingLeft: '2rem',
              marginTop: '3rem',
              marginBottom: '-2rem',
              color: 'white',
              backgroundColor: '#81c5c0',
            }}
          >
            <FormattedMessage id="comorbidity.headers.procedure" />
          </h4>
          <HistoryCollapseContainer
            documents={filter(d => path(['content', 'diagnosisType'], d) === 'procedure', normalize(documents))}
            emptyText="comorbidity.emptyText.procedure"
            sorter={sorter}
            mapper={historyMapper(names[0], onStartEdit)}
            limit={3}
            noNormalize
          />
        </div>
      )}
    </Paper>
    {editingDocument && (
      <BottomFormControls
        name={names[0]}
        editId={editingDocument.documentId}
        commitId={getLatestUnfinishedCommit(editingDocument).commitId}
      />
    )}
  </div>
);

Comorbidity.propTypes = {
  names: PropTypes.array,
  documents: PropTypes.array,
  onStartEdit: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default Comorbidity;
